import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import Loading from "../Loading";
import { db } from "../../firebaseInit"
import { onAuthStateChanged, getAuth } from "firebase/auth";
/*cant rely on the user from firebaseInit because it may not be updated in time
onAuthStateChanged always hits by the way. You must subcsribe/unsubcribe from 
onAuthStateChanged to avoid the func from getting called when unmounted */

const CheckStudentAuthenticated = ({ComponentWithAuth}) => {
    const[isStudent, setIsStudent] = useState(false);
    const[isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const auth = getAuth();

    const asyncWrapper = async(user) => {
        if(user) {
            const querySnapshot = await getDocs(collection(db, "StudentProfile"), where("uID", "==", user.uid), limit(1));
            if(querySnapshot.docs.length !== 0) {
                setIsStudent(true)
            } else {
                navigate('/signup')
            }
        } else {
            navigate('/signup')
        }
        setIsLoading(false)
    }

    useEffect(() => {
        onAuthStateChanged(auth, asyncWrapper);
    }, [])

    if(isLoading) {
        return <Loading/>
    }
    if(isStudent) {
        return <ComponentWithAuth />
    } 
}

export default CheckStudentAuthenticated;